import type { ProjectScope } from '../sync/project-scope.ts';
import {
    enqueueStructuredEntityWrite,
    type StructuredEntityWriteRegistration,
} from '../sync/structured-entity-write.ts';

type SetWriteOptions = {
    actorId?: string;
};

const SET_WRITE_REGISTRATION: StructuredEntityWriteRegistration = {
    feature: 'department_tracking',
    capability: 'EDIT_SETS',
    conflictPrefix: 'sets',
    allowedKinds: ['patchEntity', 'deleteEntity'],
    authErrorMessage: 'Authentication required to preserve set project writes',
};

export async function deleteSet(
    scope: ProjectScope,
    setId: string,
    options: SetWriteOptions = {}
): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: SET_WRITE_REGISTRATION,
        entityId: setId,
        kind: 'deleteEntity',
        payload: { id: setId },
        actorId: options.actorId,
    });
}
